module.exports = __webpack_public_path__ + "media/images/menu-icons/live-e05ca5084d7ad5dff252224361656fa0.svg";